import { LoginMethod, UserRole } from '@mi-front/core';
import { UsersAddValues } from './createUserForm.schema';

export const defaultUsersAddValues: UsersAddValues = {
  email: '',
  name: '',
  surname: '',
  role: UserRole.CLIENT_USER,
  groupId: 'NONE',
  loginMethod: LoginMethod.USERNAME_PASSWORD,
};
